import type { User } from "@/api/generated";

type InvestmentDiagnosisProfile = Pick<
  User,
  "annual_income" | "real_estate_loan_amount" | "home_loan_amount" | "job_category" | "financial_asset"
>;

/** 投資力診断の物件価格目安と融資コメント。コメントがある人は登録時のマッチをスキップできる。 */
export const getInvestmentDiagnosisResult = (
  user?: InvestmentDiagnosisProfile | null
): { priceEstimate: number; resultLowComment: string | null } => {
  if (!user) return { priceEstimate: 0, resultLowComment: null };

  const annualIncome = Number(user.annual_income ?? 0);
  const incomeMultiplier = annualIncome >= 1500 ? 20 : annualIncome >= 1000 ? 14 : annualIncome >= 700 ? 12 : 10;
  const priceEstimate = Math.max(
    0,
    annualIncome * incomeMultiplier - Number(user.real_estate_loan_amount ?? 0) - Number(user.home_loan_amount ?? 0)
  );
  const isSelfEmployed = user.job_category === "自営業";
  const isLowAssetTier = ["なし", "〜500万円", "500〜1,000万円"].includes(user.financial_asset ?? "");

  let resultLowComment: string | null = null;
  if (isSelfEmployed && isLowAssetTier) {
    resultLowComment = "会社員では無い為、融資が難しいor金利が高くなる可能性があります。";
  } else if (!isSelfEmployed && isLowAssetTier && annualIncome <= 450) {
    resultLowComment = "ご年収が450万円に乗ると融資のステップへ進みやすいです！";
  } else if (priceEstimate <= 1000) {
    resultLowComment = "他のローンとの兼ね合いで返済比率オーバーの恐れがあります。";
  }

  return { priceEstimate, resultLowComment };
};
